/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable import/no-import-module-exports */
import {
  ActivityHeader,
  AnimatedCardsFrame,
  Line,
  Modal,
  ModuleActionBar,
} from '@components';
import { useScreenSize } from '@hooks';
import { activityApi, userApi } from '@store';
import { Button, Flex, theme, Typography } from '@styles';
import { ActivitiesSideNavTemplate } from '@templates';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { findCheckPoint } from 'src/constants/rankPoints';

import StatementCard from './components/StatementCard';

const CardsDefinitionsPage = () => {
  const { i18n } = useTranslation();
  const { state } = useLocation();
  const { isTabletLG, isTabletSM } = useScreenSize();

  const [isReportModalVisible, setReportModalVisible] = useState(false);
  const [reportId, setReportId] = useState(null);

  const { data: cardDefinitions, refetch: refetchCardDefinitions } =
    activityApi.useGetCardDefinitionByModuleIdQuery(
      { moduleId: state.moduleId },
      {
        refetchOnMountOrArgChange: true,
        skip: !state?.moduleId,
      }
    );

  useEffect(() => {
    refetchCardDefinitions();
  }, [i18n.language]);

  const cards = cardDefinitions?.cards?.map((item) => {
    const lessonTitle = `${i18n.t('Activities.Cards.Lesson')} #${item?.lesson?.order_number}. ${item?.lesson?.title}`;
    const lessonCards = item?.cards?.map((card) => ({
      ...card,
      topText: lessonTitle,
    }));
    return lessonCards;
  });

  const handleReportButtonClick = () => {
    setReportModalVisible(true);
  };

  const getActiveCard = (card) => {
    setReportId(card?.id);
  };

  const [isRankPointsModalVisible, setRankPointsModalVisible] = useState(false);
  const handleRankButtonClick = () => {
    setRankPointsModalVisible(true);
  };
  const { data: userData } = userApi.useGetUserQuery();
  const rankCheckPoint = useMemo(
    () =>
      userData?.data?.rank_points &&
      findCheckPoint(userData?.data?.rank_points),
    [userData?.rank_points]
  );

  return (
    <ActivitiesSideNavTemplate
      isReportModalVisible={isReportModalVisible}
      reportId={reportId}
      setReportModalVisible={setReportModalVisible}
    >
      <Modal
        isVisible={isRankPointsModalVisible}
        modalContainerProps={{
          backgroundColor: theme.colors.white[10],
          border: `1px solid ${theme.colors.white[10]}`,
          borderRadius: '0px',
          maxHeight: isTabletSM ? '100%' : '480px',
          maxWidth: '640px',
          width: '100%',
          zIndex: 100,
        }}
        setModalVisible={setRankPointsModalVisible}
        withBackdropNoise
        // {...(isTabletSM && { modalMaxHeight: '100%' })}
      >
        <Flex flexDirection="column" p={40} width="100%">
          <Typography
            color={theme.colors.white[100]}
            textAlign="center"
            variant="MS-bold-s28-lh29"
          >
            {`${userData?.data?.rank_points}/${rankCheckPoint} `}
            {i18n.t('MainPage.PointsToNextRank').toUpperCase()}
          </Typography>
          <Flex border="3px solid rgb(255, 255, 255, 0.2)" my={24} width="100%">
            <Flex
              background={theme.colors.schoolBusYellow[100]}
              height="12px"
              m="2px"
              width={`${(100 * userData?.data?.rank_points) / rankCheckPoint}%`}
            />
          </Flex>
          <Flex
            background="rgb(255, 255, 255, 0.2)"
            height="2px"
            my={24}
            width="100%"
          />
          <Button
            onClick={() => setRankPointsModalVisible(false)}
            variant="secondary"
          >
            <Typography variant="MS-regular-s16-lh25">
              {i18n.t('ActivityModal.Close')}
            </Typography>
          </Button>
        </Flex>
      </Modal>
      <Flex flex={1} flexDirection="column" mb={50} pl={isTabletLG ? 0 : 45}>
        <ModuleActionBar
          additionalButton={{ isVisible: false }}
          progress={{ isSemivisible: true, percentage: 0 }}
          rank={{
            data: userData?.data?.rank ? { ...userData?.data?.rank } : null,
            isVisible: true,
            onClick: handleRankButtonClick,
            variant: 'rank',
          }}
          report={{
            isVisible: true,
            onClick: handleReportButtonClick,
            variant: 'report',
          }}
          sidePanel={{ isSemivisible: true }}
        />
        <ActivityHeader
          activityVariant="card_form_activity"
          containerProps={{ mb: 20, mt: 24 }}
          title={
            module?.course_module?.title ||
            i18n.t('ActivityModal.CardForm.titleText')
          }
        />
        <AnimatedCardsFrame
          data={cards?.flat()}
          getActiveCard={getActiveCard}
        />
        <Flex flexDirection="column" mt={64}>
          <Typography
            color={theme.colors.white[100]}
            mb={40}
            variant="BN-regular-s36-lh43"
          >
            {i18n.t('Activities.Cards.Terms').toUpperCase()} (
            {cards?.flat()?.length})
          </Typography>
          {cards?.map((lessonCards) => (
            <Flex flexDirection="column" gap={24}>
              <Flex
                alignItems={isTabletSM ? 'flex-start' : 'center'}
                flexDirection={isTabletSM ? 'column' : 'row'}
                gap={24}
                py={24}
                {...(isTabletSM && {
                  borderBottom: `2px solid ${theme.colors.whiteLine[100]}`,
                })}
              >
                <Typography
                  color={theme.colors.white[60]}
                  variant="MS-regular-s24-lh37"
                >
                  {lessonCards?.[0]?.topText}
                </Typography>
                {!isTabletSM && (
                  <Line flex={1} lineColor={theme.colors.whiteLine[100]} />
                )}
              </Flex>
              {lessonCards?.map((card) => (
                <StatementCard
                  definition={card?.definition}
                  statement={card?.statement}
                />
              ))}
            </Flex>
          ))}
        </Flex>
      </Flex>
    </ActivitiesSideNavTemplate>
  );
};
export default CardsDefinitionsPage;
